  <template>
  <div>
    <common-dialog ref="dialog" unit="工单用料" width="1300px" id-key="UserId" @close-saved="$emit('close-saved')" @closed="$emit('onClosed')"
      @details-opened="detailsOpened">
      <template slot="form">
        <el-row style="text-align: center; margin: 15px">
          <el-col :span="6">
            <div>
              <span>库存仓：</span>
              <el-select style="width: 180px" v-model="WarehouseId" clearable>
                <el-option v-for="item in warehouseList1" :key="item.key" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span>需求类别：</span>
              <el-select style="width: 180px" v-model="SummaryType">
                <el-option label="按工单汇总" value='0'> </el-option>
                <el-option label="按日生产汇总" value='1'> </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="onQuery">查询</el-button>
            <el-button type="primary" @click="onPrint">打印</el-button>
          </el-col>
        </el-row>
        <el-table ref="table" :data="tableData" @row-click="onRowClick" style="margin-bottom: 15px" class="table_bottom table-line tb-c-head"  border>
          <el-table-column prop="ProductNo" label="材料编号" align="center" />
          <el-table-column prop="ProductName" label="材料名称" min-width="126" align="center" />
          <el-table-column prop="ProductSpec" label="规格型号" min-width="126" align="center" />
          <el-table-column prop="ProcessStageName" label="加工阶段" min-width="110" align="center" />
          <el-table-column prop="Quantity" label="需求数量" min-width="110" align="right">
            <template slot-scope="{row}">
              <div>{{$commonJs.toThousands(row.Quantity)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="WarehouseQuantity2" label="车间仓数量" min-width="110" align="right">
            <template slot-scope="{row}">
              <div>{{$commonJs.toThousands(row.WarehouseQuantity2)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="WarehouseQuantity1" label="库存仓数量" min-width="110" align="right">
            <template slot-scope="{row}">
              <div>{{$commonJs.toThousands(row.WarehouseQuantity1)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="ShouldQuantity" label="应领数量" min-width="110" align="right">
            <template slot-scope="{row}">
              <div>{{$commonJs.toThousands(row.ShouldQuantity)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="ExistQuantity" label="可用量" min-width="110" align="right">
            <template slot-scope="{row}">
              <div>{{$commonJs.toThousands(row.CanQuantity)}}</div>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="tb-head-color" :border="true" row-key="warehousingdetail" 
          :data="tableRowData" :row-style="{ height: '40px' }" :cell-style="{ padding: '0px' }" style="width: 100%"
          >
          <el-table-column label="类型" prop="PreType" width="200"></el-table-column> 
          <el-table-column label="单据编码" prop="DocNo" width="160">
            <template slot-scope="{ row }">
              <div>{{ row.DocNo }}</div>
            </template>
            <!-- <template slot-scope="{ row }">
              <el-link type="primary"  @click="toPage(row)">{{ row.DocNo }}</el-link>
            </template> -->
          </el-table-column>
          <el-table-column label="单据类型" prop="DocType"></el-table-column>
          <el-table-column label="主单位" prop="BaseUnitName"></el-table-column>
          <el-table-column label="主单位在途量" prop="BaseQuantity" align="right">
            <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.BaseQuantity) }}</span>
              </template>
          </el-table-column>
          <!-- <el-table-column label="客户" prop="ClothTradeUnitName"></el-table-column> -->
          <el-table-column label="供应商/加工商" prop="TradeUnitName"></el-table-column>
          <el-table-column label="部门" prop="DpName"></el-table-column>
          <el-table-column label="完成时间" prop="EndTime">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.EndTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="辅单位" prop="SubUnitName"></el-table-column>
          <el-table-column label="辅单位在途量" prop="SubUnitQuantity" align="right">
            <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.SubUnitQuantity) }}</span>
              </template>
          </el-table-column>
        </el-table>
      </template>

      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/production/workDoc").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      stReportApi: require('@/api/stock/stReport').default,
      WorkDocIds:[],
      warehouseList: [],
      tableData: [],
      tableRowData: [],
      WarehouseId: null,
      SummaryType: '1',
      summaryShow: false,
      total: null,
      warehouseList1:[],
    };
  },
  methods: {
    detailsOpened(data) {
      this.WorkDocIds = data
      const o = {
        Ids: data,
        SummaryType: this.SummaryType,
      }
      this.api.GetDailyDocInfoList(o).then((res) => {
        console.log("GetDailyDocInfoList", res);
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });
      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.GeneralWarehouseId = res.Data[0].WarehouseId;
            this.data.GeneralWarehouseName = res.Data[0].WarehouseName;
          }

          this.warehouseList1 = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });
    },
    onRowClick(row) {
      this.stReportApi.preEntryList({ColorId:row.ColorId,ProductId:row.ProductId,PropertyId:row.PropertyId}).then(res => {
        if(res.Code === 0){
          this.tableRowData = res.Data
        }
      })
    },
    toPage(row){
      let PreType = row.PreType;
      let params = {
        DocNo: row.DocNo,
        DocType: row.DocType,
        type: '明细'
      }
      if(PreType === '生产待入量' || PreType === '委外待入量' || PreType === '生产（材料）待发量' || PreType === '委外（材料）待发量'){
        this.$router.push({ name: "newworkorder", params: params });
      }else if(PreType === '采购在途量'){
        this.$router.push({ name: "emptor", params: params });
      }else if(PreType === '销售待发量'){
        this.$router.push({ name: "saleorder", params: params });
      }
      
    },
    onQuery(){
      const o = {
        Ids: this.WorkDocIds,
        WarehouseId: this.WarehouseId,
        SummaryType: this.SummaryType,
      }

      this.api.GetDailyDocInfoList(o).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data;
        }
      });
    },
    close() {
      this.WarehouseId = null;
      this.WorkDocId = null;
      this.warehouseList = [];
      this.$refs.dialog.close(true);
    },
    onPrint(){
      let newpage = this.$router.resolve({
        path: '/materialPrint',
        query: {
          Ids: this.WorkDocIds,
          WarehouseId: this.WarehouseId,
          SummaryType: this.SummaryType
        }
      });
      window.open(newpage.href, '_blank');
    }
  },
};
</script>
<style scoped>
</style>